import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { MetadocNavigationContext } from "pages/metadoc/utils/metadocRoutes";

export type ProcessingMetadoc = {
  metadocId: number;
  fileId: number;
  name: string;
  status: "pending" | "processing" | "completed" | "failed";
  createdAt: number;
  errorMessage?: string;
  navigationContext?: MetadocNavigationContext;
};

type MetadocState = {
  processingMetadocs: ProcessingMetadoc[];
};

const initialState: MetadocState = {
  processingMetadocs: [],
};

const metadocSlice = createSlice({
  name: "metadoc",
  initialState,
  reducers: {
    addProcessingMetadoc: (state, action: PayloadAction<ProcessingMetadoc>) => {
      state.processingMetadocs.push(action.payload);
    },
    updateProcessingMetadoc: (
      state,
      action: PayloadAction<ProcessingMetadoc>,
    ) => {
      const index = state.processingMetadocs.findIndex(
        (m) => m.metadocId === action.payload.metadocId,
      );
      if (index !== -1) {
        state.processingMetadocs[index] = action.payload;
      }
    },
    updateProcessingMetadocStatus: (
      state,
      action: PayloadAction<{
        metadocId: number;
        status: ProcessingMetadoc["status"];
        errorMessage?: string;
      }>,
    ) => {
      const metadoc = state.processingMetadocs.find(
        (m) => m.metadocId === action.payload.metadocId,
      );
      if (metadoc) {
        metadoc.status = action.payload.status;
        if (action.payload.errorMessage) {
          metadoc.errorMessage = action.payload.errorMessage;
        }
      }
    },
    removeProcessingMetadoc: (state, action: PayloadAction<number>) => {
      state.processingMetadocs = state.processingMetadocs.filter(
        (m) => m.metadocId !== action.payload,
      );
    },
    clearAllProcessingMetadocs: (state) => {
      state.processingMetadocs = [];
    },
  },
});

export const {
  addProcessingMetadoc,
  updateProcessingMetadoc,
  updateProcessingMetadocStatus,
  removeProcessingMetadoc,
  clearAllProcessingMetadocs,
} = metadocSlice.actions;

export default metadocSlice.reducer;
